import BaseEntity from '@/entity/BaseEntity';
import { useNotif } from '@orion.ui/orion';
import type UserProfileInformationsEntity from './user-profile/UserProfileInformationsEntity';
import useUserProfessionalExperienceService from '@/services/user/UserProfessionalExperienceService';

export default class UserProExpEntity extends BaseEntity<IProfessionalExperienceModel> implements ResourceEntity {
	private userProfileInformationsEntity?: UserProfileInformationsEntity;

	get id () { return this.state.id; }
	get position () { return this.state.position; }
	set position (val) { this.state.position = val; }
	get company () { return this.state.company; }
	set company (val) { this.state.company = val; }
	get isCurrentPosition () { return this.state.isCurrentPosition; }
	set isCurrentPosition (val) {this.state.isCurrentPosition = val; }
	get startDate () { return this.state.startDate ? new Date(this.state.startDate) : undefined; }
	set startDate (val) { this.state.startDate = val?.toPost(true) ?? ''; }
	get endDate () { return this.state.endDate ? new Date(this.state.endDate) : undefined; }
	set endDate (val) { this.state.endDate = val?.toPost(true) ?? undefined; }
	get professionalSkills () { return this.state.professionalSkills; }
	set professionalSkills (val) {this.state.professionalSkills = val;}
	get dataForApiAdd (): OmitUserId<IAddProfessionalExperienceModel> {
		return {
			startDate: this.startDate?.toPost() ?? '',
			endDate: this.endDate?.toPost(),
			company: this.company,
			position: this.position,
			isCurrentPosition: this.isCurrentPosition,
			professionalSkillIds: this.professionalSkills?.map(x => x.id),
		};
	}

	get dataForApiUpdate (): IUpdateProfessionalExperienceModel {
		return {
			id: this.id,
			startDate: this.startDate?.toPost() ?? '',
			endDate: this.endDate?.toPost() ?? undefined,
			company: this.company,
			position: this.position,
			isCurrentPosition: this.isCurrentPosition,
			professionalSkillIds: this.professionalSkills?.map(x => x.id),
		};
	}

	connectUserProfileInformationsEntity (userProfileInformationsEntity: UserProfileInformationsEntity) {
		this.userProfileInformationsEntity = userProfileInformationsEntity;
	}

	async createAsync (cb?: Function) {
		try {
			const data = await useUserProfessionalExperienceService().addAsync(this.dataForApiAdd);
			this.userProfileInformationsEntity?.addProExp(data);
			useNotif.success('Création réussie', 'Votre expérience professionnelle a bien été créée et enregistrée');
			cb?.();
		} catch (e: any) {
			useNotif.success('Oops', e?.response?.data);
		}
	}

	async updateAsync (cb?: Function) {
		try {
			const data = await useUserProfessionalExperienceService().updateAsync(this.dataForApiUpdate);
			this.userProfileInformationsEntity?.professionalExperiences.findByKey(this.id)?.assignData(data);
			cb?.();
		} catch (e: any) {
			useNotif.success('Oops', e?.response?.data);
		}
	}

	async deleteAsync () {
		try {
			await useUserProfessionalExperienceService().deleteAsync(this.id);
			this.userProfileInformationsEntity?.deleteProExp(this.id);
		} catch (e: any) {
			useNotif.success('Oops', e?.response?.data);
		}
	}
}
